<schaeffler-app-shell
  [appTitle]="title"
  [hasSidebarLeft]="true"
  [userName]="username$ | ngrxPush"
  [userImageUrl]="profileImage$ | ngrxPush"
  [hasFooter]="true"
>
  <ng-container sidenavBody>
    <nav class="mapping-navigation" aria-label="Mapping Tool navigation">
      <section class="navigation-section">
        <span class="navigation-heading text-subtitle-1">Administration</span>

        <ul class="navigation-list">
          <li>
            <a routerLink="admin/manage-application-systems" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="triggerEscapeKey()">
              Application Systems
            </a>
          </li>

          <li>
            <a routerLink="admin/manage-assets" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="triggerEscapeKey()">
              Assets
            </a>
          </li>

          <li>
            <a routerLink="admin/manage-customers" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="triggerEscapeKey()">
              Customers
            </a>
          </li>

          <li>
            <a routerLink="admin/manage-sectors" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="triggerEscapeKey()">
              Sectors
            </a>
          </li>

          <li>
            <a routerLink="admin/manage-section-roll-names" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="triggerEscapeKey()">
              Section Roll Names
            </a>
          </li>

          <li>
            <a routerLink="admin/manage-subsectors" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="triggerEscapeKey()">
              Sub-sectors
            </a>
          </li>

          <li>
            <a routerLink="admin/manage-user-accounts" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="triggerEscapeKey()">
              User Accounts
            </a>
          </li>
        </ul>
      </section>
      
      <mat-divider role="separator" class="mat-divider !my-4 mat-divider-horizontal" aria-orientation="horizontal"></mat-divider>

      <section class="navigation-section">
        <span class="navigation-heading text-subtitle-1">Industries</span>

        <ul class="navigation-list">
          <li>
            <a routerLink="/paper-machines" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="triggerEscapeKey()">
              Paper and Pulp
            </a>
          </li>

          <li>
            <button
              type="button"
              class="navigation-group"
              [attr.aria-expanded]="isCementMiningOpen"
              (click)="isCementMiningOpen = !isCementMiningOpen"
            >
              <span>Cement and Mining</span>
              <span aria-hidden="true">
                {{ isCementMiningOpen ? '−' : '+' }}
              </span>
            </button>

            <ul
              *ngIf="isCementMiningOpen"
              class="navigation-sublist"
            >
              <li>
                <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="triggerEscapeKey()">
                  Dashboard
                </a>
              </li>

              <li>
                <a
                  routerLink="/cement-mining/assets-management"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="triggerEscapeKey()"
                >
                  Assets Management
                </a>
              </li>

              <li>
                <a
                  routerLink="/cement-mining/"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="triggerEscapeKey()"
                >
                  Bearing Management
                </a>
              </li>

              <li>
                <a
                  routerLink="/cement-mining/mapping-overview"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="triggerEscapeKey()"
                >
                  Mapping Snapshot
                </a>
              </li>

              <li>
                <a
                  routerLink="/cement-mining/my-submissions"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="triggerEscapeKey()"
                >
                  My Submissions
                </a>
              </li>

              <li>
                <a
                  routerLink="/cement-mining/pending-reviews"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="triggerEscapeKey()"
                >
                  Pending Reviews
                </a>
              </li>

              <li>
                <a
                  routerLink="/cement-mining/upload-mapping-info"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="triggerEscapeKey()"
                >
                  Upload Data Mapping
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </section>
    </nav>
  </ng-container>
  <ng-container mainContent>
    <div class="fullscreen-bg h-full w-full">
      <router-outlet></router-outlet>
    </div>
  </ng-container>
</schaeffler-app-shell>
